import TextField from "./WorksheetTextField";
import { useMutation, useQuery } from "@apollo/client";
import { Alert, Button, MenuItem, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { SAVE_SETTINGS, SETTINGS } from "./api";
export default function WorksheetSettings() {
  const { data, error } = useQuery(SETTINGS);
  const [save, { loading }] = useMutation(SAVE_SETTINGS);
  const [method, setMethod] = useState("production");
  const [markup, setMarkup] = useState("0");
  const [notice, setNotice] = useState("");
  const [failure, setFailure] = useState("");
  useEffect(() => {
    if (data) {
      setMethod(data.worksheetSettings.method);
      setMarkup(data.worksheetSettings.markup);
    }
  }, [data]);
  if (error) return <Alert severity="error">{error.message}</Alert>;
  if (!data?.worksheetSettings.enabled || !data.worksheetSettings.canManageSettings) return null;
  return (
    <Stack spacing={2} sx={{ my: 3 }}>
      <Typography variant="h6">Estimating defaults</Typography>
      <Typography variant="body2">
        Applies to new proposals. Existing proposals retain their estimating method.
      </Typography>
      <TextField
        select
        label="Default estimating method"
        value={method}
        onChange={(e) => setMethod(e.target.value)}
        disabled={loading}
      >
        <MenuItem value="production">Production-based</MenuItem>
        <MenuItem value="worksheet">Worksheet</MenuItem>
      </TextField>
      <TextField
        label="Default worksheet markup (%)"
        type="number"
        value={markup}
        onChange={(e) => setMarkup(e.target.value)}
        inputProps={{ min: 0, step: "0.0001" }}
        disabled={loading}
      />
      <Button
        disabled={loading}
        onClick={async () => {
          setFailure("");
          setNotice("");
          try {
            await save({ variables: { method, markup }, refetchQueries: [SETTINGS] });
            setNotice("Estimating defaults saved.");
          } catch (e) {
            setFailure((e as Error).message);
          }
        }}
      >
        Save estimating defaults
      </Button>
      {notice && <Alert severity="success">{notice}</Alert>}
      {failure && <Alert severity="error">{failure}</Alert>}
    </Stack>
  );
}
